__turbopack_context__.v({
  "container": "SliderMaxFourCards-module-scss-module__ttX9NG__container",
  "entryEffect": "SliderMaxFourCards-module-scss-module__ttX9NG__entryEffect",
  "section": "SliderMaxFourCards-module-scss-module__ttX9NG__section",
  "slide": "SliderMaxFourCards-module-scss-module__ttX9NG__slide",
  "slideFill": "SliderMaxFourCards-module-scss-module__ttX9NG__slideFill",
  "swiper": "SliderMaxFourCards-module-scss-module__ttX9NG__swiper",
  "visible": "SliderMaxFourCards-module-scss-module__ttX9NG__visible",
});
